export default __webpack_public_path__ + "assets/images/icon-shape.4f345e6ec570136c2ed45b95d685864c.svg";